import React, { createContext, memo, useContext, useEffect, useState } from "react";
import { CPropertyBuildingFormKeys } from "../../../../util/schemas/building-form/building.schema";
import { CPropertyFormKeys } from "../../../../util/schemas/property-schema/propertySchema";

interface IBuildingDetailContext {
  indexBuilding: number;
  nameBuilding: string;
  nameBuildingUnits: string;
}

const BuildingDetailContext = createContext<IBuildingDetailContext>(
  {} as IBuildingDetailContext
);

interface IBuildingDetailProviderProps {
  children: React.ReactNode;
  indexBuilding: number;
  uuid: string;
}

export const BuildingDetailProvider = memo(
  (props: IBuildingDetailProviderProps) => {
    const { children, indexBuilding } = props;

    const values: IBuildingDetailContext = {
      indexBuilding,
      nameBuilding: `${CPropertyFormKeys.building}.${indexBuilding}`,
      nameBuildingUnits: `${CPropertyFormKeys.building}.${indexBuilding}.${CPropertyBuildingFormKeys.units}`
    };

    return (
      <BuildingDetailContext.Provider value={values}>
        {children}
      </BuildingDetailContext.Provider>
    );
  },
  (prevProps, nextProps) => {
    return prevProps.indexBuilding === nextProps.indexBuilding;
  }
);

export const useBuildingDetail = () => useContext(BuildingDetailContext);
